<template>
  <div>
    <div class="message">Do you want the sentences read out loud?</div>
    <div>
      <button
        class="sf-btn select-btn"
        v-on:click.prevent="$emit('select', true)"
      >
        <span class="btn-icon result-ok">
          <CheckSvg />
        </span>
        <span class="btn-label"> Yes </span>
      </button>
      <button
        class="sf-btn select-btn"
        v-on:click.prevent="$emit('select', false)"
      >
        <span class="btn-icon result-wrong">
          <XSvg />
        </span>
        <span class="btn-label"> No </span>
      </button>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.select-btn {
  @apply tw-border tw-border-solid tw-border-primary tw-mx-4;
}

.select-btn .btn-icon {
  @apply tw-pr-4;
}
.select-btn .btn-label {
  @apply tw-pr-4;
}
.select-btn svg {
  @apply tw-inline-block;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import { sfPlayActivityAudio } from "@/state/sfActivityState";
import CheckSvg from "@/svg/CheckSvg.vue";
import XSvg from "@/svg/XSvg.vue";

export default defineComponent({
  components: { CheckSvg, XSvg },
  emits: ["select"],
  mounted() {
    sfPlayActivityAudio("intro");
  },
});
</script>
